export default {
  en : {
    MainTitle : 'Project Tracker',
    Title : 'Project Updates',
    Economics : 'Economics (ALL USD)',
    Project : "Project",
    ProjectLeader : "Project Leader",
    LatestUpdate : "Last update",
    StatusSummary : "Status Summary",
    Timeline : "Timeline",
    ModifiedBy : 'Modified by',
    ConfirmSubmission : "Do you really want to submit this update?",
    SubmitSuccess : "The selected update has been successfully submitted",
    ConfirmDelete : "Do you really want to delete this update?",
    KPUDeleted : "The selected update has been successfully deleted",
    GoldPrice : "Gold Price used",
    AnnualProductionOz : "Annual Payable Prod. (Oz)",
    TotalProductionOz : "Total Payable Prod. (Oz)",
    ProductionStartUpDate : "Production Start Up",
    MineLifeYears : "Mine Life (yrs)",
    InitialCapex : "Initial Capex (M$)",
    InitialCapexTooltip : "Growth CAPEX, owners costs and sustaining CAPEX of project, excluding closure and remediation or sunk costs",
    ExchangeRate : "Exchange rate",
    CostToFirstOunce : "Cost to first oz (M$)",
    CostToFirstOunceTooltip : "Total cost of growth CAPEX, studies, including drilling cost to get first ounce of gold",
    CashCost : "Cash Cost",
    AISC : "AISC",
    IRRStandard : "IRR at {goldPrice}$/oz and FX={fxRate}",
    IRRAfterTax : "IRR (after tax)",
    NPVAfterTax : "NPV (after tax) (M$)",
    NPVStandard : "NPV at {goldPrice}$/oz and FX={fxRate} (M$)",
    StandardFXRate : "FX Rate",
    StandardGoldPrice : "Gold Price",
    YearlyCashFlows : "Cashflow over 5 years",
    YearlyCashFlowsTooltip : "Please insert the cashflow values for the next five years here including exploration, studies, construction, permitting, etc…  These values can be cash outflows (negative) or cash inflows if there is more revenue than expenses (positive)",
    CashFlow : "Cashflow (M$)",
    CumulativeCashFlow : "Cumul. Cashflow (M$)",
    Edit : "Edit a project update",
    Tab1 : "General information",
    Tab2 : "Economics",
    Tab3 : "Disciplines",
    Tab4 : "Challenges",
    Tab5 : "Milestones",
    Tab6 : "Opportunities",
    Tab7 : "Documents",
    OpenDocumentLibrary : "Open the document library",
    NoDocumentLibrary : "No associated document library",
    Report : "Report",
    PaginatedReport : "One pager report",
    Discipline : {
      'Title' : "Disciplines",
      'Name' : "Update/Changes",
      'Comments' : "Comments",
      'Status' : "Status",
      '0' : "Permitting",
      '1' : "Environment",
      '2' : "Human Resources",
      '3' : "Land, Social & Communities",
      '4' : "Studies",
      '5' : "Construction",
      '6' : "Mining",
      '7' : "Reserves",
      '8' : "Costs",
      '9' : "Geology",
      '10' : "Exploration",
      '11' : "Others",
      '12' : "Engineering",
      '13' : "Infrastructure",
      '14' : "Metallurgy",
      '15' : "Geotechnical",
      '16' : "Water Management"
    },
    Filters : {
      Title : "Filters",
      All : "All",
      Completed : "Completed",
      Trashed : "Trashed"
    },
    ToDo : {
      Name : "Name",
      Description : "Add a description",
      DueDate : "Due Date "
    },
    Challenges : {
      'Title' : "Key Challenges",
      'Add' : 'Add a challenge',
      'Edit' : 'Edit a challenge',
      'Name' : "Challenge/Risk",
      'Comments' : "Comments",
      'Status' : "Status"
    },
    Milestones : {
      'Title' : "Key Milestones",
      'Add' : 'Add a milestone',
      'Edit' : 'Edit a milestone',
      'Name' : "Milestone",
      'Comments' : "Comments",
      'Status' : "Status"
    },
    Opportunities : {
      'Title' : "Opportunities",
      'Add' : 'Add an opportunity',
      'Edit' : 'Edit an oppportunity',
      'Name' : "Opportunity"
    },
    KPUStatus : {
      '0' : "On Target",
      '1' : "Close follow-up required",
      '2' : "Behind Target"
    },
    Reports: {
      KPU : "KPU"
    },
    KeyProjectType: {
      Title : "Project Types",
      Name : "Name",
      IsCapitalExpenseRequest : "Capital Expense",
      ConfirmDelete : "Do you really want to delete this project type?",
      KeyProjectTypeDeleted : "The project type has been successfully deleted",
      AddNew: "Add project type",
      Edit : "Update project type"
    },
    KeyProject: {
      Title : "Projects",
      ProjectName : "Name",
      Property : 'Operation',
      District : 'Region',
      Country : 'Country',
      IsActive : "Is active?",
      KeyProjectType : "Project type",
      DocumentLibraryUrl : "Document Library link",
      ConfirmDelete : "Do you really want to delete this project?",
      KeyProjectTypeDeleted : "The project has been successfully deleted",
      AddNew: "Add project",
      Edit : "Update project"
    },
    Admin: {
      Title : "Admin"
    }
  }
}
